import React, { useEffect, useState } from 'react';
import {
  CircleImage,
  roleTranslator,
  UniversalDropdownSelector,
} from 'shared/ui';
import styles from './manager-selector.module.scss';
import { CheckMarkSvg } from 'shared/svg';
import { BusinessApi } from 'shared/api';
import { IManagersAccountList } from 'shared/api/business/interfaces/managers-account-list.interface';

interface IManagerSelector {
  setManager: (accountId: string, role: string) => void;
  clearData?: boolean;
  pointId: string;
}

export const ManagerSelector: React.FC<IManagerSelector> = ({
  pointId,
  setManager,
}) => {
  const [managers, setManagers] = useState<IManagersAccountList[]>([]);
  const [selectedManager, setSelectedManager] =
    useState<Partial<IManagersAccountList>>();
  const clickHandler = async () => {
    if (managers.length > 0) {
      return;
    }
    const managersList = await BusinessApi.getManagersAccountList({ pointId });
    setManagers(managersList);
  };
  useEffect(() => {
    clickHandler();
  }, []);

  const selectManagerHandler = (id: string | undefined) => {
    if (selectedManager?.accountId == id) {
      setSelectedManager(undefined);
      setManager('', '');
      return;
    }
    if (id) {
      const manager = managers.find((manager) => manager?.accountId === id);
      setSelectedManager(manager);
      setManager(id, manager?.role || '');
    }
  };
  const managerCard = (manager: Partial<IManagersAccountList>) => {
    return (
      <div
        className={`${styles.container__card} ${selectedManager?.accountId == manager.accountId ? styles.container__card__selected : ''}`}
        key={manager.accountId}
        onClick={() => {
          selectManagerHandler(manager.accountId);
        }}
      >
        <div className={styles.card__data}>
          <CircleImage imgSrc={manager.imgUrl} imgSize={32} />
          <div className={styles.data__info}>
            <div className={styles.info__role}>
              {roleTranslator(manager.role)}
            </div>
            <div className={styles.info__name}>{manager.fio}</div>
          </div>
        </div>
        <div
          className={`${styles.card__checkbox} ${selectedManager?.accountId == manager.accountId ? styles.card__checkbox__selected : ''}`}
        >
          {selectedManager?.accountId == manager.accountId && <CheckMarkSvg />}
        </div>
      </div>
    );
  };

  const managersComp = (
    <div className={styles.selector__container}>
      {managers.map((manager) => managerCard(manager))}
    </div>
  );
  const selectedManagerComp = selectedManager ? (
    <div className={styles.selector__container}>
      {managerCard(selectedManager)}
    </div>
  ) : (
    <></>
  );
  return (
    <UniversalDropdownSelector
      title="Выбор из текущих сотрудников"
      options={managersComp}
      selectedOption={selectedManagerComp}
      onClick={clickHandler}
    />
  );
};
